import styled from "styled-components";

const ClientReportTableRowColumn = styled.td`
    width: ${({ width }) => width ? `${width}%` : 'auto'};
    max-width: 0 !important;
    padding: 0.6rem !important;
    vertical-align: middle;
`;

export default ClientReportTableRowColumn;